import { render, staticRenderFns } from "./SampleSidepanel.vue?vue&type=template&id=673ca89a&scoped=true&"
import script from "./SampleSidepanel.vue?vue&type=script&lang=js&"
export * from "./SampleSidepanel.vue?vue&type=script&lang=js&"
import style0 from "./SampleSidepanel.vue?vue&type=style&index=0&id=673ca89a&lang=scss&scoped=true&"
import style1 from "./SampleSidepanel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673ca89a",
  null
  
)

export default component.exports